







import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import MembershipCategorySingle from '@subscriptions/components/singles/admin/membership-category-single.vue';
import { MembershipCategory } from '@subscriptions/interfaces/subscription-category';

@Component({
  name: 'bpc-membership-category',
  components: {
    'bpc-membership-category-single': MembershipCategorySingle,
  },
})
export default class MembershipCategories extends Vue {
  // PROPS
  @Prop({ type: [Number, String] }) readonly id: number | string;
  @Prop(Object) readonly initialData: MembershipCategory;

  // DATA
  // public formModel: MembershipCategory = null;

  // LIFECYCLE
  // created(){}
  // mounted(){}
  // updated(){}
  // destroyed(){}

  // COMPUTED
  get modelId(): number {
    return Number(this.id);
  }

  // METHODS

  // WATCHERS
}
